import React, { createContext, useContext, useState } from 'react';
import { User } from 'firebase/auth';
import { Funcionario } from '../types';

interface AuthContextType {
  user: User | null;
  funcionario: Funcionario | null;
  setUser: (user: User | null) => void;
  setFuncionario: (funcionario: Funcionario | null) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [funcionario, setFuncionario] = useState<Funcionario | null>(null);

  const logout = () => {
    setUser(null);
    setFuncionario(null);
  };

  return (
    <AuthContext.Provider value={{ user, funcionario, setUser, setFuncionario, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
